<template>
    <!-- currency: lets next-admin scope the brand filter to the selected
         economic zone (EUR/GBP). clientId: first brand of the user, if any. -->
    <AdminNextIframe
        path="/physical-stock/"
        with-currency
        :query="initialQuery"
        @message="onIframeMessage" />
</template>

<script>
import { mapGetters } from 'vuex';
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

// Filter/pagination query keys owned by the next-admin physical stock view.
// We mirror only these into admin-v2's own URL so they survive a parent
// refresh, while never exposing auth params (token, lang, adminOrigin…).
const STOCK_FILTER_KEYS = [
    'month',
    'q',
    'page',
    'perPage',
    'brands',
    'colors',
    'conditions',
    'stockGte',
    'stockLte',
];

export default {
    name: 'StockPhysical',
    components: { AdminNextIframe },
    computed: {
        ...mapGetters(['activeUser']),
        // Re-inject any filter params persisted in admin-v2's URL so the iframe
        // boots on the same view after a parent refresh.
        initialQuery() {
            const query = { clientId: this.activeUser?.clients?.[0]?.id };
            STOCK_FILTER_KEYS.forEach((key) => {
                query[key] = this.$route.query[key];
            });
            return query;
        }
    },
    methods: {
        // The iframe emits a `navigate` message on every in-app route change.
        // We mirror its filter query into admin-v2's URL (auth params excluded)
        // so a parent refresh rebuilds the iframe on the same filtered view.
        onIframeMessage(event) {
            if (event.data?.type !== 'navigate') return;
            const query = event.data.data?.query;
            if (!query) return;

            const nextQuery = {};
            STOCK_FILTER_KEYS.forEach((key) => {
                if (query[key] != null && query[key] !== '') {
                    nextQuery[key] = query[key];
                }
            });

            if (!this._sameQuery(nextQuery)) {
                this.$router.replace({ query: nextQuery }).catch(() => {});
            }
        },
        _sameQuery(next) {
            const current = this.$route.query;
            const keys = new Set([...Object.keys(next), ...STOCK_FILTER_KEYS]);
            for (const key of keys) {
                if ((current[key] ?? '') !== (next[key] ?? '')) return false;
            }
            return true;
        }
    }
}
</script>
